import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { MosaicBlockConfig } from '@front-platform/content-builder';
import { mosaicBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { IMosaicBlockCard } from '../../models/mosaic-block-card';
import { IPushTextButtonV2 } from '../../atoms/push-text-button-v2-atom/push-text-button-v2-atom.component';
import { IPushPicture } from '../../atoms/push-picture-atom/push-picture-atom.component';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';

export interface IPush {
  type: string;
  items: IPushTextButtonV2[] | IPushPicture[];
}
export interface MosaicBlockRuntimeConfig {
  'cards'?: Array<IMosaicBlockCard> | Array<any> | undefined;
  'items'?: IPush[] | undefined;
}

export type MosaicBlockConfigInput = Partial<
  Omit<MosaicBlockConfig, keyof MosaicBlockRuntimeConfig> & MosaicBlockRuntimeConfig
>;
export type MosaicBlockResolvedConfig = Omit<MosaicBlockConfig, keyof MosaicBlockRuntimeConfig> &
  Partial<MosaicBlockRuntimeConfig>;
export interface MosaicBlockContract extends ConfigComponentContract<
  MosaicBlockConfigInput,
  MosaicBlockResolvedConfig
> {}

@Component({
  selector: 'app-mosaic-block',
  templateUrl: './mosaic-block.component.html',
  styleUrls: ['./mosaic-block.component.scss'],
  standalone: false,
})
export class MosaicBlockComponent implements OnInit, MosaicBlockContract {
  readonly config = input<MosaicBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<MosaicBlockConfig, MosaicBlockRuntimeConfig>(
    mosaicBlockResolveConfig,
    () => ({ config: this.config() }),
  );
  get cards(): Array<IMosaicBlockCard> | Array<any> | undefined {
    return this.resolvedConfig()['cards'] as unknown as
      Array<IMosaicBlockCard> | Array<any> | undefined;
  }
  get items(): IPush[] | undefined {
    return this.resolvedConfig()['items'] as unknown as IPush[] | undefined;
  }
  get topMargin(): string {
    return this.resolvedConfig()['top_margin'] as unknown as string;
  }
  get bottomMargin(): string {
    return this.resolvedConfig()['bottom_margin'] as unknown as string;
  }
  get backgroundColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor;
  }
  get fullWidth(): boolean {
    return this.resolvedConfig()['full_width'] as unknown as boolean;
  }

  legacyCards?: Array<IMosaicBlockCard>;

  constructor() {}

  ngOnInit(): void {
    if (!this.cards?.[0]?.block) {
      this.legacyCards = this.cards;
    }
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(MosaicBlockComponent, { 'keyAliases': {} });
